import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const dashboardApi = {
  getAverageDailyProductionCapacity: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/dashboard/averageDailyProductionCapacity`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getTobaccosInStock: async (data) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/dashboard/tobaccosInStock`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getTotalStats: async (data) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/dashboard/totalStats`, {
        params: data,
      });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default dashboardApi;
